import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditUser from "../../components/users/FormAddEditUser";

const CreateUser = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/users");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditUser
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateUser;